// import images
import logo from "assets/images/logo-background1.png";
import profile from "assets/images/profile-img.png";
// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation";
import PropTypes from "prop-types";
import React from "react";
import MetaTags from "react-meta-tags";
//redux
import { useDispatch, useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap";
// actions
import { loginUser } from "../../store/actions";
const Login = props => {
  const dispatch = useDispatch();
  const { error } = useSelector(state => ({
    error: state.Login.error,
  }));

  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    dispatch(loginUser(values, props.history));
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>Đăng nhập | Tổ chức giải pháp</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-3">
                        <h5 className="text-primary">Chào mừng bạn !</h5>
                        <p>4Si E-Invoice</p>
                        <img
                          src={logo}
                          alt=""
                          style={{
                            transform: "scale(1.3)",
                            marginLeft: "14px",
                          }}
                          height="34"
                        />
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  {/* <div>
                    <Link to="/" className="auth-logo-light">
                      <div
                        className="avatar-md profile-user-wid mb-4"
                        style={{
                          marginLeft: "20px",
                        }}
                      >
                        <span className="avatar-title bg-light">
                          <img
                            src={logo}
                            alt=""
                            // style={{
                            //   transform: "scale(1.4)",
                            // }}
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div> */}
                  <div className="p-2">
                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v);
                      }}
                    >
                      {error ? (
                        <Alert
                          color="danger"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "3px",
                          }}
                        >
                          <i className="bx bx-error-circle font-19" />
                          {error}
                        </Alert>
                      ) : null}

                      <div className="mb-3">
                        <AvField
                          name="email"
                          label="Email"
                          className="form-control"
                          type="email"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: "Vui lòng nhập email",
                            },
                          }}
                          placeholder="Nhập email"
                        />
                      </div>

                      <div className="mb-3">
                        <AvField
                          name="password"
                          label="Mật khẩu"
                          type="password"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: "Vui lòng nhập mật khẩu",
                            },
                          }}
                          placeholder="Nhập mật khẩu"
                        />
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                        >
                          Đăng nhập
                        </button>
                      </div>
                    </AvForm>
                    {/* <div className="mt-4 text-center">
                      <Link to="/forgot-password" className="text-muted">
                        <i className="mdi mdi-lock me-1" />
                        Forgot your password?
                      </Link>
                    </div> */}
                  </div>
                </CardBody>
              </Card>
              {/* <div className="mt-5 text-center">
                <div>
                  © {new Date().getFullYear()}. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by LCS
                </div>
              </div> */}
              <div className="mt-4 font-size-18 text-center text-danger">
                <p>
                  4Si E-Invoice © {new Date().getFullYear()} - Hotline: 19001837
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
